import clsx, { ClassValue } from "clsx";

interface ILoaderSpinner {
	className?: ClassValue;
}

const LoaderSpinner = ({ className }: ILoaderSpinner) => {
	return (
		<svg
			className={clsx("animate-spin ", className)}
			viewBox="0 0 154 156"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<ellipse
				cx="76.9126"
				cy="78"
				rx="56.2232"
				ry="57.0181"
				stroke="#5067EF"
				strokeOpacity="0.25"
				strokeWidth="14"
			/>
			<path
				d="M76.5234 20.9833C91.4343 20.8786 105.776 26.7853 116.392 37.4039C127.009 48.0226 133.031 62.4834 133.134 77.6052"
				stroke="url(#paint0_linear_327_4165)"
				strokeWidth="14"
				strokeLinecap="round"
				strokeDasharray="4 4"
			/>
			<defs>
				<linearGradient
					id="paint0_linear_327_4165"
					x1="125.45"
					y1="106.776"
					x2="27.6854"
					y2="50.4202"
					gradientUnits="userSpaceOnUse">
					<stop stopColor="#5067EF" />
					<stop offset="0.755208" stopColor="#5067EF" stopOpacity="0.01" />
					<stop offset="1" stopColor="#1681FF" stopOpacity="0" />
					<stop offset="1" stopColor="#5067EF" stopOpacity="0" />
				</linearGradient>
			</defs>
		</svg>
	);
};

export default LoaderSpinner;
